import React, { useState } from 'react';
import { Spinner } from '../components/UI';

const TAMANO_LOTE = 10;

export default function ImportarCatalogoML() {
  const [archivo, setArchivo] = useState(null);
  const [analizando, setAnalizando] = useState(false);
  const [publicaciones, setPublicaciones] = useState([]);
  const [totalEncontradas, setTotalEncontradas] = useState(0);
  const [error, setError] = useState('');

  const [procesando, setProcesando] = useState(false);
  const [progreso, setProgreso] = useState(0);
  const [totalAProcesar, setTotalAProcesar] = useState(0);
  const [resultadosAcumulados, setResultadosAcumulados] = useState([]);
  const [terminado, setTerminado] = useState(false);

  const analizarArchivo = async () => {
    if (!archivo) return;
    setAnalizando(true); setError('');
    try {
      const formData = new FormData();
      formData.append('file', archivo);
      const res = await fetch((process.env.REACT_APP_API_URL || '') + '/importar/catalogo-ml-excel/previsualizar', {
        method: 'POST', body: formData,
      });
      if (!res.ok) throw new Error('No se pudo leer el archivo');
      const data = await res.json();
      setPublicaciones(data.publicaciones || []);
      setTotalEncontradas(data.total_encontradas || 0);
    } catch (e) {
      setError(e.message);
    }
    setAnalizando(false);
  };

  const procesarLotes = async (cantidadAProcesar) => {
    setProcesando(true); setError(''); setProgreso(0); setResultadosAcumulados([]); setTerminado(false);
    setTotalAProcesar(cantidadAProcesar);

    const aProcesar = publicaciones.slice(0, cantidadAProcesar);
    const acumulado = [];

    for (let i = 0; i < aProcesar.length; i += TAMANO_LOTE) {
      const lote = aProcesar.slice(i, i + TAMANO_LOTE);
      try {
        const res = await fetch((process.env.REACT_APP_API_URL || '') + '/importar/catalogo-ml-excel/procesar', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ publicaciones: lote }),
        });
        if (res.ok) {
          const data = await res.json();
          acumulado.push(...(data.resultados || []));
        }
      } catch { }
      setProgreso(Math.min(i + TAMANO_LOTE, aProcesar.length));
      setResultadosAcumulados([...acumulado]);
    }

    setProcesando(false);
    setTerminado(true);
  };

  const importados = resultadosAcumulados.filter(r => r.estado === 'importado').length;
  const yaExistian = resultadosAcumulados.filter(r => r.estado === 'ya_existia').length;
  const errores = resultadosAcumulados.filter(r => r.estado === 'error').length;

  return (
    <div className="page-content">
      <h1 className="page-title">Importar catálogo desde Mercado Libre</h1>
      <p style={{ color: 'var(--gris-4)', fontSize: '.875rem', marginTop: '-.75rem', marginBottom: '1.25rem' }}>
        Subí el Excel de "Publicaciones" que exportás desde Mercado Libre. El sistema lee cada
        service (título, precio real y descripción) y usa IA para extraer las tareas y repuestos
        de cada uno, cargándolos automáticamente al catálogo.
      </p>

      {!publicaciones.length && (
        <div className="card" style={{ marginBottom: '1rem' }}>
          <input type="file" accept=".xlsx,.xls" onChange={e => setArchivo(e.target.files[0])}
            style={{ marginBottom: '.75rem' }} />
          <button className="btn btn-primary" disabled={!archivo || analizando} onClick={analizarArchivo}>
            {analizando ? 'Analizando...' : 'Analizar archivo'}
          </button>
          {analizando && <Spinner texto="Leyendo publicaciones..." />}
          {error && <p style={{ color: 'var(--rojo)', fontSize: '.875rem', marginTop: '.5rem' }}>{error}</p>}
        </div>
      )}

      {publicaciones.length > 0 && !procesando && !terminado && (
        <div className="card" style={{ marginBottom: '1rem' }}>
          <p style={{ fontWeight: 600, color: 'var(--verde)', marginBottom: '.6rem' }}>
            ✅ Se encontraron {totalEncontradas} publicaciones activas
          </p>
          <p style={{ fontSize: '.875rem', color: 'var(--gris-5)', marginBottom: '.75rem' }}>Primeras de la lista:</p>
          {publicaciones.slice(0, 5).map((p, i) => (
            <div key={i} style={{ padding: '.4rem 0', borderBottom: '1px solid var(--gris-2)', fontSize: '.875rem' }}>
              <strong>{p.titulo}</strong> — ${p.precio?.toLocaleString()}
            </div>
          ))}

          <div style={{ display: 'flex', gap: '.5rem', marginTop: '1rem', flexWrap: 'wrap' }}>
            <button className="btn btn-outline" onClick={() => procesarLotes(Math.min(50, totalEncontradas))}>
              🧪 Probar con las primeras 50
            </button>
            <button className="btn btn-primary" onClick={() => procesarLotes(totalEncontradas)}>
              📥 Importar las {totalEncontradas} publicaciones
            </button>
          </div>
        </div>
      )}

      {procesando && (
        <div className="card" style={{ marginBottom: '1rem' }}>
          <p style={{ fontWeight: 600, color: 'var(--azul)', marginBottom: '.75rem' }}>
            Procesando con IA... {progreso} de {totalAProcesar}
          </p>
          <div style={{ background: 'var(--gris-2)', borderRadius: '999px', height: 10, overflow: 'hidden' }}>
            <div style={{
              background: 'var(--azul)', height: '100%',
              width: `${(progreso / Math.max(totalAProcesar, 1)) * 100}%`,
              transition: 'width .3s'
            }} />
          </div>
          <p style={{ fontSize: '.8125rem', color: 'var(--gris-4)', marginTop: '.5rem' }}>
            Esto puede tardar varios minutos según la cantidad. No cierres esta pantalla.
          </p>
        </div>
      )}

      {terminado && (
        <div className="card">
          <p style={{ fontWeight: 600, color: 'var(--verde)', marginBottom: '.75rem' }}>
            ✅ Proceso terminado
          </p>
          <div className="resumen-grid" style={{ marginBottom: '1rem' }}>
            <div className="resumen-card"><div className="label">Importados</div><div className="valor">{importados}</div></div>
            <div className="resumen-card"><div className="label">Ya existían</div><div className="valor">{yaExistian}</div></div>
            <div className="resumen-card"><div className="label">Errores</div><div className="valor">{errores}</div></div>
          </div>
          {errores > 0 && (
            <div style={{ marginBottom: '1rem' }}>
              <p style={{ fontSize: '.8125rem', color: 'var(--gris-5)', marginBottom: '.4rem' }}>
                Ejemplos de errores (para diagnosticar):
              </p>
              {resultadosAcumulados.filter(r => r.estado === 'error').slice(0, 5).map((r, i) => (
                <div key={i} style={{ fontSize: '.8125rem', color: 'var(--rojo)', padding: '.3rem 0', borderBottom: '1px solid var(--gris-2)' }}>
                  <strong>{r.titulo || r.item_id}:</strong> {String(r.error).slice(0, 200)}
                </div>
              ))}
            </div>
          )}
          <button className="btn btn-secondary" onClick={() => { setPublicaciones([]); setTerminado(false); setArchivo(null); }}>
            Importar otro archivo
          </button>
        </div>
      )}
    </div>
  );
}
